<template v-once>
  <img src="@/assets/icons/sermo_icon.png" alt="sermo icon">
</template>

<script>
export default {
  name: "Sermo",
};
</script>

<style scoped>
</style>